<template>
  <rest-list-page :page-title="pageTitle" :fetch-endpoint="fetchEndpoint">
    <template slot="actions">
      <router-link :to="createRoute" v-if="!readonly">
        <el-button type="primary" icon="el-icon-plus">
          {{ $t('Alarms_AlarmList_CreateAlarm') }}
        </el-button>
      </router-link>
    </template>

    <template slot="table">
      <rest-list-column-enum
        prop="message_type"
        :title="$t('Alarms_Field_MessageType')"
        :enum="MessageTypeLabel"
      ></rest-list-column-enum>

      <rest-list-column
        prop="treshold"
        :title="$t('Alarms_Field_Threshold')"
        :filterable="false"
      ></rest-list-column>

      <rest-list-column-enum
        prop="period"
        :title="$t('Alarms_Field_Period')"
        :enum="AlarmPeriodLabels"
      ></rest-list-column-enum>

      <rest-list-column-actions v-if="readonly">
        <template slot-scope="scope">
          <rest-list-action-view :route="rowViewRoute(scope.row)" />
        </template>
      </rest-list-column-actions>

      <rest-list-column-actions v-else>
        <template slot-scope="scope">
          <rest-list-action-update :route="rowUpdateRoute(scope.row)" />
          <rest-list-action-delete :endpoint="rowDeleteEndpoint(scope.row)" />
        </template>
      </rest-list-column-actions>
    </template>
  </rest-list-page>
</template>

<script>
import { MessageTypeLabel } from '@/common/enum/MessageTypeEnum'
import { AlarmPeriodLabels } from '@/modules/alarms/enum/AlarmPeriodLabels'
import RestListPage from '@/common/components/rest/RestListPage'
import RestListColumn from '@/common/components/rest/RestListColumn'
import RestListColumnEnum from '@/common/components/rest/RestListColumnEnum'
import RestListColumnActions from '@/common/components/rest/RestListColumnActions'
import RestListActionUpdate from '@/common/components/rest/RestListActionUpdate'
import RestListActionView from '@/common/components/rest/RestListActionView'
import RestListActionDelete from '@/common/components/rest/RestListActionDelete'
import { projectEndpoint, projectRoute } from '@/core/helpers'

export default {
  name: 'AlarmListPage',

  components: {
    RestListPage,
    RestListColumn,
    RestListColumnEnum,
    RestListColumnActions,
    RestListActionDelete,
    RestListActionUpdate,
    RestListActionView
  },

  data() {
    return {
      MessageTypeLabel,
      AlarmPeriodLabels
    }
  },

  computed: {
    pageTitle() {
      return this.$t(this.$route.meta.title)
    },

    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `alarms`,
        params: {}
      })
    },

    createRoute() {
      return projectRoute({
        name: 'AlarmCreate'
      })
    },

    readonly() {
      return !this.$can('manageProjectTechnical')
    }
  },

  methods: {
    rowViewRoute(row) {
      return projectRoute({
        name: 'AlarmView',
        query: { id: row.id }
      })
    },

    rowUpdateRoute(row) {
      return projectRoute({
        name: 'AlarmUpdate',
        query: { id: row.id }
      })
    },

    rowDeleteEndpoint(row) {
      return projectEndpoint({
        method: 'delete',
        url: `alarms/${row.id}`
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/alarms/pages/AlarmListPage.vue